import React, { useState, useEffect } from "react";
import { Container, Image, Button } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { map } from "lodash";
import { Course } from "../../../api";
import "./HomeCourses.scss";

const courseController = new Course();

export function HomeCourses() {
  const [courses, setCourses] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const response = await courseController.getCourses({ limit: 6 });
        setCourses(response.courses.docs);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  return (
    <Container className="home-courses">
      <h2>Últimos cursos</h2>
      <div className="home-courses__all-courses">
        {map(courses, (course) => (
          <a
            key={course._id}
            href={course.ur}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image src={`${course.miniature}`} />
            <div>
              <span>{course.title}</span>
              <span>{course.description}</span>
            </div>
          </a>
        ))}
      </div>
      <div className="home-courses__more">
        <Button as={Link} to="/courses" primary>
          Ver todos los cursos
        </Button>
      </div>
    </Container>
  );
}
